/**
 * Known keys. You don't need to import this as you would still be able to use normalized string.
 * @module keyboard/keys
 */
export const Keys = {
    BACKSPACE: 'Backspace',
    DOWN: 'Down',
    ENTER: 'Enter',
    ESCAPE: 'Escape',
    LEFT: 'Left',
    RIGHT: 'Right',
    SHIFT: 'Shift',
    SPACE: 'Space',
    TAB: 'Tab',
    UP: 'Up',
};
